import React from "react";
import { Box, Button, Heading, Text } from "grommet";

const PageMainCanvas = (props: any) => {
    return (
        <Box height="full"
            margin={{horizontal:"10px"}} 
            border 
            round="5px" 
            pad="10px" 
            background="rgba(255,255,255,0.9)">
            {props.children}
        </Box>
    );
}

export default PageMainCanvas;
